import { ListUserDto } from "./user.models";
import { WorkOrderStatus } from "./workorder.models";

export interface PastExecutionDto {
	WorkOrderId: string;
	Title: string;
	Status: WorkOrderStatus;
	Created: Date;
	Updated: Date;
}

export interface ListWorkOrderScheduleDto {
	ScheduleId: string;
	ScheduleName: string;
	Description?: string;
	WorkOrderTemplateId: string;
	TemplateName: string;
	RecurrenceType: RecurrenceType;
	StartDate: Date;
	EndDate?: Date;
	TimeOfExecution: string;
	IsActive: boolean;
	Status: WorkOrderScheduleStatus;
	Created: Date;
	CreatedBy: ListUserDto;
	Deleted: boolean;
}

export interface WorkOrderScheduleDto {
	Id: number;
	ScheduleId: string;
	ScheduleName: string;
	Description?: string;
	WorkOrderTemplateId: string;
	TemplateName: string;
	RecurrenceType: RecurrenceType;
	RecurrencePattern: RecurrencePatternDto;
	ExcludedDaysOfWeek: number[];
	StartDate: Date;
	EndDate?: Date;
	TimeOfExecution: string;
	IsActive: boolean;
	Status: WorkOrderScheduleStatus;
	LastExecuted?: Date;
	UpcomingExecutions: Date[];
	PastExecutions: PastExecutionDto[];
	Created: Date;
	CreatedBy: ListUserDto;
	Updated?: Date;
	UpdatedBy?: ListUserDto;
	Deleted?: Date;
	DeletedBy?: ListUserDto;
}

export interface CreateWorkOrderScheduleDto {
	ScheduleName: string;
	Description?: string;
	WorkOrderTemplateId: string;
	RecurrenceType: RecurrenceType;
	RecurrencePattern: RecurrencePatternDto;
	ExcludedDaysOfWeek: number[];
	StartDate: Date;
	EndDate?: Date;
	TimeOfExecution: string;
	IsActive?: boolean;
}

export interface UpdateWorkOrderScheduleDto {
	ScheduleName: string;
	Description?: string;
	RecurrenceType: RecurrenceType;
	RecurrencePattern: RecurrencePatternDto;
	ExcludedDaysOfWeek: number[];
	EndDate?: Date;
	TimeOfExecution: string;
	IsActive: boolean;
}

export interface RecurrencePatternDto {
	WeekInterval?: number;
	DaysOfWeek?: number[];
	DayOfMonth?: number;
	WeekOfMonth?: number;
	DayOfWeekForMonthly?: number;
}

export enum WorkOrderScheduleStatus {
	Scheduled = 1,
	Active = 2,
	Inactive = 3,
	Completed = 4
}

export enum RecurrenceType {
	Daily = 0,
	Weekly = 1,
	Monthly = 2,
	OneTime = 3
}

export const DaysOfWeek = [
	{ label: "Monday", value: 1 },
	{ label: "Tuesday", value: 2 },
	{ label: "Wednesday", value: 3 },
	{ label: "Thursday", value: 4 },
	{ label: "Friday", value: 5 },
	{ label: "Saturday", value: 6 },
	{ label: "Sunday", value: 7 }
];

export const MonthlyWeekOptions = [
	{ label: "1st", value: 1 },
	{ label: "2nd", value: 2 },
	{ label: "3rd", value: 3 },
	{ label: "4th", value: 4 },
	{ label: "Last", value: 5 }
];
